import { render, staticRenderFns } from "./AddresseeList.vue?vue&type=template&id=ff9e1534&scoped=true&lang=pug"
import script from "./AddresseeList.vue?vue&type=script&lang=js"
export * from "./AddresseeList.vue?vue&type=script&lang=js"
import style0 from "./AddresseeList.vue?vue&type=style&index=0&id=ff9e1534&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9e1534",
  null
  
)

export default component.exports